const t = (n) => {
  const e = n.type;
  return e.displayName || e.name || e.value || "Unknown";
};
export {
  t as getComponentDisplayName
};
//# sourceMappingURL=index.es670.js.map
